// Ersatz für `dotenv` im Browser-Bundle: src/shared/const.ts ruft `dotenv.config()` auf, das im
// Browser schon mit Webpack 4 ins Leere lief (fs war ein leeres Modul). Webpack 5 bringt keine
// Node-Polyfills mehr mit, deshalb hier ein ausdrücklicher No-op statt process/fs/path-Polyfills.
module.exports = {
    config: () => ({parsed: {}}),
    parse: () => ({}),
};
